module.exports = __webpack_public_path__ + "img/feedback5.76fc7367.webp";